import Button from "./Button";
import { ButtonProps, ButtonStyles } from "./types";

export default Button;

export { Button };
export type { ButtonProps, ButtonStyles };
